import color from '../../../theme/color';

/**
 * featureStyle
 *
 * Generic function to add style on a feature
 */
export const featureStyle = (Ol, fill, stroke, zindex) => {
  return new Ol.style.Style({
    fill: new Ol.style.Fill({
      color: fill.color ? fill.color : null
    }),
    stroke: new Ol.style.Stroke({
      color: stroke.color ? stroke.color : null,
      width: stroke.width ? stroke.width : null,
      lineDash: stroke.lineDash ? stroke.lineDash : null
    }),
    zIndex: zindex ? zindex : 0
  });
};

/**
 * renderFeatureStyle
 *
 * @param {String}   type
 * @param {Boolean}  hasShopData
 */
export const renderFeatureStyle = (Ol, type, hasShopData = false) => {
  let style;

  const placeStyle = featureStyle(
    Ol,
    { color: '#E9E9E9' },
    { color: '#FFFFFF', width: 1 }
  );
  const historicStyle = featureStyle(
    Ol,
    { color: 'rgba(255, 255, 255, 0)' },
    { color: '#E9E9E9', width: 1, lineDash: [1, 3] }
  );
  const unavailableStyle = featureStyle(
    Ol,
    { color: '#999999' },
    { color: '#FFFFFF', width: 0 }
  );
  const shopStyle = featureStyle(
    Ol,
    { color: color.shopping },
    { color: '#FFFFFF', width: 1 }
  );
  const restaurantStyle = featureStyle(
    Ol,
    { color: color.restaurant },
    { color: '#FFFFFF', width: 1 }
  );
  const selectedPlaceStyle = featureStyle(
    Ol,
    { color: color.other },
    { color: '#FFFFFF', width: 1 }
  );
  const hiddenStyle = featureStyle(
    Ol,
    { color: 'rgba(255, 255, 255, 0)' },
    { color: 'rgba(255, 255, 255, 0)', width: 0 }
  );
  const itineraryStyle = featureStyle(
    Ol,
    { color: 'rgba(233, 233, 233, 0.3)' },
    { color: '#FFFFFF', width: 1 }
  );
  const unavailableItineraryStyle = featureStyle(
    Ol,
    { color: 'rgba(153, 153, 153, 0.3)' },
    { color: '#FFFFFF', width: 0 }
  );
  const unavailable2019 = featureStyle(
    Ol,
    { color: color.map.unavailable2019 },
    { color: 'rgba(255, 255, 255, 0)', width: 0 },
    50
  );

  if (type) {
    if (type.includes('builder')) {
      type = 'builder';
    }
  }

  switch (type) {
    case 'place':
      style = placeStyle;
      break;

    case 'historic':
      style = historicStyle;
      break;

    case 'technical':
      style = unavailableStyle;
      break;

    case 'unavailable':
      style = unavailable2019;
      break;

    case 'builder':
      style = shopStyle;
      break;

    case 'shop':
      style = shopStyle;
      break;

    case 'restaurant':
      style = restaurantStyle;
      break;

    case 'selectedPlace':
      style = selectedPlaceStyle;
      break;

    case 'hidden':
      style = hiddenStyle;
      break;

    case 'itinerary':
      style = itineraryStyle;
      break;

    case 'services':
      style = unavailable2019;
      break;

    case 'building':
      style = placeStyle;
      break;

    default:
      style = placeStyle;
      break;
  }

  if (type === 'itinerary') {
    style = !hasShopData ? unavailableItineraryStyle : itineraryStyle;
  } else if (type === 'place') {
    style = !hasShopData ? unavailableStyle : style;
  }

  return style;
};
